import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Company\FetchCompanyListController::__invoke
* @see app/Http/Controllers/Company/FetchCompanyListController.php
* @route '/api/company'
*/
const FetchCompanyListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchCompanyListController.url(options),
    method: 'get',
})

FetchCompanyListController.definition = {
    methods: ["get","head"],
    url: '/api/company',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Company\FetchCompanyListController::__invoke
* @see app/Http/Controllers/Company/FetchCompanyListController.php
* @route '/api/company'
*/
FetchCompanyListController.url = (options?: RouteQueryOptions) => {
    return FetchCompanyListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Company\FetchCompanyListController::__invoke
* @see app/Http/Controllers/Company/FetchCompanyListController.php
* @route '/api/company'
*/
FetchCompanyListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchCompanyListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Company\FetchCompanyListController::__invoke
* @see app/Http/Controllers/Company/FetchCompanyListController.php
* @route '/api/company'
*/
FetchCompanyListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchCompanyListController.url(options),
    method: 'head',
})

export default FetchCompanyListController